export const IMAGE_HEIGHT = 40;
export const BORDER_RADIUS = 8;
